export const REPORT = "@layout/REPORT";
export const SHOW_TOAST = "@layout/SHOW_TOAST";
export const DISMISS_TOAST = "@layout/DISMISS_TOAST";



// WEBPACK FOOTER //
// ./src/app/layout/constants.js